import React from 'react'

function UpdateSession() {
  return (
    <div>UpdateSession</div>
  )
}

export default UpdateSession